import React from 'react'
import { styled } from '@mui/material/styles'
import { BASE_COLORS } from 'asterX-UI/colors.constant'
import { COLOR_VARIANTS } from 'asterX-UI/theme.constant'
import PropTypes from 'prop-types'

// Функция для получения нужного цвета
const getColor = (color, theme, val = 600) => {
  const [primary, secondary, info, warning, error, success] = COLOR_VARIANTS
  if (color === primary) {
    return theme.palette.allPrimary[val]
  }
  if (color === info) {
    return theme.palette.allInfo[val]
  }
  if (color === warning) {
    return theme.palette.allWarning[val]
  }
  if (color === error || color === secondary) {
    return theme.palette.allError[val]
  }
  if (color === success) {
    return theme.palette.allSuccess[val]
  }
  return BASE_COLORS.White
}

// Styled компонент для стилизации innerCircle
const InnerCircle = styled('div')(({ theme, color }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '50%',
  borderStyle: 'solid',
  border: '8px',
  padding: '3px',
  borderColor: getColor(color, theme, 50),
  color: getColor(color, theme),
  backgroundColor: getColor(color, theme, 200)
}))

export const FutureIconContainer = ({ color, children, ...props }) => {
  return (
    <InnerCircle color={color} {...props}>
      {children}
    </InnerCircle>
  )
}

FutureIconContainer.propTypes = {
  color: PropTypes.oneOf(['primary', 'secondary', 'info', 'warning', 'error', 'success']),
  children: PropTypes.node
}
